import { z } from 'zod';
import { TicketSource, StaffRole, FacilityType, Gender, QueueDispatch } from '../enums';

export const IssueKioskTicketSchema = z.object({
  facilityId: z.string().uuid(),
  serviceCategoryId: z.string().uuid(),
  patientName: z.string().max(120).optional(),
});
export type IssueKioskTicketDto = z.infer<typeof IssueKioskTicketSchema>;

export const IssueOnlineTicketSchema = z.object({
  facilityId: z.string().uuid(),
  serviceCategoryId: z.string().uuid(),
  patientName: z.string().max(120).optional(),
  patientPhone: z.string().max(20).optional(),
  preferredDate: z.string().date().optional(),
});
export type IssueOnlineTicketDto = z.infer<typeof IssueOnlineTicketSchema>;

export const CreateFacilitySchema = z.object({
  name: z.string().min(2).max(200),
  slug: z.string().min(2).max(80).regex(/^[a-z0-9-]+$/),
  address: z.string().max(400),
  lat: z.number().min(-90).max(90).optional(),
  lng: z.number().min(-180).max(180).optional(),
  phone: z.string().max(20),
  facilityType: z.nativeEnum(FacilityType),
});
export type CreateFacilityDto = z.infer<typeof CreateFacilitySchema>;

export const UpdateFacilitySchema = z.object({
  name: z.string().min(2).max(200).optional(),
  address: z.string().max(400).optional(),
  lat: z.number().min(-90).max(90).nullable().optional(),
  lng: z.number().min(-180).max(180).nullable().optional(),
  phone: z.string().max(20).optional(),
  facilityType: z.nativeEnum(FacilityType).optional(),
  isActive: z.boolean().optional(),
});
export type UpdateFacilityDto = z.infer<typeof UpdateFacilitySchema>;

export const CreateDepartmentSchema = z.object({
  name: z.string().min(2).max(200),
  code: z.string().min(1).max(20).regex(/^[A-Z0-9_]+$/),
  deptType: z.string(),
  description: z.string().max(500).optional(),
  displayOrder: z.number().int().min(0).default(0),
});
export type CreateDepartmentDto = z.infer<typeof CreateDepartmentSchema>;

export const CreateServiceCategorySchema = z.object({
  departmentId: z.string().uuid(),
  name: z.string().min(2).max(200),
  prefix: z.string().min(1).max(5).regex(/^[A-Z]+$/),
  avgServiceTimeMins: z.number().int().min(1).default(10),
  displayOrder: z.number().int().min(0).default(0),
});
export type CreateServiceCategoryDto = z.infer<typeof CreateServiceCategorySchema>;

export const CreateStaffSchema = z.object({
  email: z.string().email(),
  role: z.nativeEnum(StaffRole),
  facilityId: z.string().uuid(),
});
export type CreateStaffDto = z.infer<typeof CreateStaffSchema>;

export const NearbyFacilitiesQuerySchema = z.object({
  lat: z.coerce.number().min(-90).max(90),
  lng: z.coerce.number().min(-180).max(180),
  radius_km: z.coerce.number().min(0.1).max(100).default(10),
});
export type NearbyFacilitiesQueryDto = z.infer<typeof NearbyFacilitiesQuerySchema>;

export const SetParamSchema = z.object({
  paramKey: z.string().min(1).max(100),
  paramValue: z.string(),
  dataType: z.string(),
  description: z.string().max(500).optional(),
});
export type SetParamDto = z.infer<typeof SetParamSchema>;

export const RequestOtpSchema = z.object({
  phone: z.string().min(7).max(20),
});
export type RequestOtpDto = z.infer<typeof RequestOtpSchema>;

export const VerifyOtpSchema = z.object({
  phone: z.string().min(7).max(20),
  otp: z.string().length(6),
  name: z.string().max(120).optional(),
});
export type VerifyOtpDto = z.infer<typeof VerifyOtpSchema>;
